/**
 * @module
 * @internal
 */
export const bluetoothInputReportId = 0x11
